import { createActions } from "redux-actions";

export const {
  //GET ORDER
  getOrderById,
  getOrderByIdSuccess,
  getOrderByIdError,
  createOrder,
  createOrderSuccess,
  createOrderError,
  createOrderClearError,
  updateOrder,
  updateOrderSuccess,
  updateOrderError,
  getOrderReport,
  getOrderReportSuccess,
  getOrderReportError,
  getSurchargePaymentData,
  getSurchargePaymentDataSuccess,
  getSurchargePaymentDataFailure,
  downloadContractByOrderId,
  downloadContractByOrderIdSuccess,
  downloadContractByOrderIdError,
  downloadNotificationToGibdd,
  downloadNotificationToGibddSuccess,
  downloadNotificationToGibddError,
  //  archieve Order
  archieveOrder,
  assignDriver,
  assignDriverSuccess,
  assignDriverFailure,
  setAssignDriverDrawerVisibility
} = createActions(
  "GET_ORDER_BY_ID",
  "GET_ORDER_BY_ID_SUCCESS",
  "GET_ORDER_BY_ID_ERROR",
  "CREATE_ORDER",
  "CREATE_ORDER_SUCCESS",
  "CREATE_ORDER_ERROR",
  "CREATE_ORDER_CLEAR_ERROR",
  "UPDATE_ORDER",
  "UPDATE_ORDER_SUCCESS",
  "UPDATE_ORDER_ERROR",
  "GET_ORDER_REPORT",
  "GET_ORDER_REPORT_SUCCESS",
  "GET_ORDER_REPORT_ERROR",
  "GET_SURCHARGE_PAYMENT_DATA",
  "GET_SURCHARGE_PAYMENT_DATA_SUCCESS",
  "GET_SURCHARGE_PAYMENT_DATA_FAILURE",
  "DOWNLOAD_CONTRACT_BY_ORDER_ID",
  "DOWNLOAD_CONTRACT_BY_ORDER_ID_SUCCESS",
  "DOWNLOAD_CONTRACT_BY_ORDER_ID_ERROR",
  "DOWNLOAD_NOTIFICATION_TO_GIBDD",
  "DOWNLOAD_NOTIFICATION_TO_GIBDD_SUCCESS",
  "DOWNLOAD_NOTIFICATION_TO_GIBDD_ERROR",
  "ARCHIEVE_ORDER",
  "ASSIGN_DRIVER",
  "ASSIGN_DRIVER_SUCCESS",
  "ASSIGN_DRIVER_FAILURE",
  "SET_ASSIGN_DRIVER_DRAWER_VISIBILITY"
);
